import { motion } from 'motion/react';
import { useRef } from 'react';
import { useInView } from '../../../components/hooks/useInView.jsx';

export function SolutionSection() {
  const [ref, isInView] = useInView({ threshold: 0.1 });
  const containerRef = useRef(null);

  const mockups = [
    {
      url: 'https://images.unsplash.com/photo-1571952288324-552b8c0daceb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwYXBwJTIwbW9iaWxlJTIwc2NyZWVufGVufDF8fHx8MTc2NDMxMDcwNXww&ixlib=rb-4.1.0&q=80&w=1080',
      title: 'Home Screen'
    },
    {
      url: 'https://images.unsplash.com/photo-1758521961236-38a86c00f1bd?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3b3Jrb3V0JTIwdHJhY2tpbmclMjBwaG9uZXxlbnwxfHx8fDE3NjQzOTc5MDR8MA&ixlib=rb-4.1.0&q=80&w=1080',
      title: 'Workout Tracking'
    },
    {
      url: 'https://images.unsplash.com/photo-1641301547846-2cf73f58fdca?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwbWVhbCUyMHBsYW5uaW5nfGVufDF8fHx8MTc2NDMzMjg5OHww&ixlib=rb-4.1.0&q=80&w=1080',
      title: 'Meal Planning'
    }
  ];

  return (
    <section ref={ref} className="py-20 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto mb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-5xl md:text-6xl mb-8">The Solution</h2>
          <div className="h-1 w-20 bg-[#fd5b38] mb-8" />
          <p className="text-xl md:text-2xl text-gray-300 max-w-4xl leading-relaxed">
            By addressing common barriers to fitness, the App empowers users to
            build sustainable habits, achieve their wellness goals, and lead
            healthier, more fulfilling lives. Our holistic approach integrates
            all aspects of wellness into one seamless experience.
          </p>
        </motion.div>
      </div>

      <div
        ref={containerRef}
        className="relative h-[600px] max-w-7xl mx-auto"
      >
        <motion.div className="flex gap-8 absolute">
          {mockups.map((mockup, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="flex-shrink-0 w-[400px]"
            >
              <div className="relative group">
                <div className="absolute inset-0 bg-[#fd5b38]/20 blur-xl group-hover:bg-[#fd5b38]/30 transition-all duration-300 rounded-3xl" />
                <div className="relative bg-[#1a1a1a] p-6 rounded-3xl item-border-1 border-gray-800 hover:border-[#fd5b38] transition-all duration-300 overflow-hidden">
                  <img
                    src={mockup.url}
                    alt={mockup.title}
                    className="w-full h-[450px] object-cover rounded-2xl"
                  />
                  <div className="mt-4 text-center">
                    <h4 className="text-xl text-[#fd5b38]">{mockup.title}</h4>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      <div className="text-center mt-12 text-gray-500">
        <p className="text-lg">Scroll to explore →</p>
      </div>
    </section>
  );
}
